import {useEffect, useState} from "react";
import {IMonthlyInvoice} from "../../../utils/interfaces/MonthlyInvoice/IMonthlyInvoice";
import {MdEdit} from "react-icons/md"
import useApiDeleteMonthlyInvoice from "./api-hooks/useApiDeleteMonthlyInvoice";
import {CustomAxiosError} from "../../../logics/api-config";
import ConfirmationModal from "../ui/ConfirmationModal";
import {useToast} from "../../../utils/contexts/toast-context";
import {useQueryClient} from "react-query";
import {MdDeleteOutline} from "react-icons/md";
import {useAccounting} from "../../../utils/contexts/accounting_context";


interface MonthlyInvoiceProps {
    obj: IMonthlyInvoice;
    restaurateur_name?: string;
}

function MonthlyInvoiceRow({obj: initialObj, restaurateur_name}: MonthlyInvoiceProps) {
    const {displayMessage, displayError} = useToast();
    const {
        selectedMonthlyInvoice,
        selectMonthlyInvoice,
        selectIsMonthlyInvoiceFormOpen,
        isMonthlyInvoiceFormOpen
    } = useAccounting()
    const queryClient = useQueryClient();

    // const [isFormOpen, setIsFormOpen] = useState<boolean>(false)
    const [obj, setObj] = useState<IMonthlyInvoice>(initialObj);
    const [isConfirmationOpen, setConfirmationOpen] = useState(false);

    const handleCancelDelete = () => {
        setConfirmationOpen(false);
    };

    const deleteMutation = useApiDeleteMonthlyInvoice();
    const {mutateAsync: apiDelete} = deleteMutation;
    const handleConfirmDelete = async () => {
        try {
            if (obj) {
                await apiDelete({id: obj.id});
                await queryClient.invalidateQueries('getMonthlyInvoicesDetails');
                displayMessage('MonthlyInvoice deleted successfully');
            }
        } catch (error) {
            const axiosError = error as CustomAxiosError;
            if (axiosError.response && axiosError.response.data && axiosError.response.data.message) {
                displayError(axiosError.response.data.message);
            } else {
                displayError('An error occurred while deleting the MonthlyInvoice');
            }
        }
        setConfirmationOpen(false);
        await queryClient.invalidateQueries('getMonthlyInvoices');
    };

    const handleSelect = (obj: IMonthlyInvoice) => {
        selectedMonthlyInvoice === obj ? selectMonthlyInvoice(undefined) : selectMonthlyInvoice(obj);
    };

    const handleToggleMonthlyInvoiceFormOpen = () => {
        if (isMonthlyInvoiceFormOpen) {
            selectIsMonthlyInvoiceFormOpen(false);
            selectMonthlyInvoice(undefined);
        }
        if (!isMonthlyInvoiceFormOpen) {
            selectIsMonthlyInvoiceFormOpen(true);
            selectMonthlyInvoice(obj);
        }
    }

    let labelStyle = "text-sm text-gray-500 font-bold mr-1";
    let contentStyle = "text-sm text-gray-800 font-bold mr-1";

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <div
                className="relative items-center flex-col w-fit gap-2 cursor-pointer bg-gray-200 shadow-xl rounded-lg px-4 py-2 mb-2 mt-2"
                style={{minWidth: 500}
                }
            >
                <div onClick={() => handleSelect(obj)}>
                    <div className="flex flex-grow">
                        <label className={labelStyle}>invoice_id: </label>
                        <label className={contentStyle}>{obj.invoice_id}</label>
                    </div>
                    <div className="flex flex-grow">
                        <label className={labelStyle}>Invoice Date: </label>
                        <label className={contentStyle}>{obj.invoice_date}</label>
                    </div>
                    <div className="flex flex-grow">
                        <label className={labelStyle}>Month: </label>
                        <label className={contentStyle}>{obj.month}</label>
                    </div>
                    <div className="flex flex-grow">
                        <label className={labelStyle}>Year: </label>
                        <label className={contentStyle}>{obj.year}</label>
                    </div>
                    <div className="flex flex-grow">
                        <label className={labelStyle}>Net Amount: </label>
                        <label className={contentStyle}>{obj.net_amount}</label>
                    </div>
                    {restaurateur_name &&
                        <div className="flex flex-grow">
                            <label className={labelStyle}>Restaurateur: </label>
                            <label className={contentStyle}>{restaurateur_name}</label>
                        </div>}
                </div>

                <div style={{position: "absolute", top: 0, right: 10}} className=''>
                    <div className="flex justify-end mt-2">
                        <button
                            onClick={() => handleToggleMonthlyInvoiceFormOpen()}
                            className="p-2 rounded-full bg-mcia_salmon text-white hover:bg-mcia_orange cursor-pointer"
                        >
                            <div className="flex items-center justify-center">
                                <MdEdit title="EDIT INVOICE"/>
                            </div>
                        </button>
                    </div>
                    <div className="flex justify-end mt-2">
                        <button
                            onClick={() => setConfirmationOpen(true)}
                            className="p-2 rounded-full bg-mcia_salmon text-red-600 hover:bg-mcia_orange cursor-pointer"
                        >
                            <div className="flex items-center justify-center">
                                <MdDeleteOutline title="DELETE INVOICE"/>
                            </div>
                        </button>
                    </div>
                </div>
            </div>


            {/*}*/}
            <ConfirmationModal
                isOpen={isConfirmationOpen}
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />


        </>
    );
}

export default MonthlyInvoiceRow;
